import { abaloneCellName, type AbaloneMove } from '../games/abalone';
import { type AmazonsMove, moveNotation } from '../games/amazons';
import type { BridgeNtMove } from '../games/bridge-nt';
import { type ChuShogiMove, chuSquareLabel } from '../games/chu-shogi';
import { rankLabel, suitLabel } from '../games/heads-up-poker';
import { type TraxMove, traxNotation } from '../games/trax';
import type { GameId } from '../wasm';

/** Readable replay labels. Private deal contents never belong in a move label. */
export function newGameMoveLabel(game: GameId, mv: unknown): string | null {
  if (game === 'Gomoku') {
    if (mv === 'TakeBlack') return '黒を選択';
    if (mv === 'TakeWhite') return '白を選択';
    if (mv === 'PlaceTwo') return '追加2石を選択';
  }
  if (typeof mv !== 'object' || mv === null) return null;
  if (game === 'Kyoen' && 'Claim' in mv) {
    const points = (mv as { Claim: { points: { row: number; col: number }[] } }).Claim.points;
    return `共円 ${points.map(p => `${p.row + 1}:${p.col + 1}`).join('・')}`;
  }
  if ((game === 'Gomoku' || game === 'Kyoen') && 'Place' in mv) {
    const { row, col } = (mv as { Place: { row: number; col: number } }).Place;
    return game === 'Gomoku' ? `${String.fromCharCode(65 + col)}${15 - row}` : `行${row + 1}・列${col + 1}`;
  }
  if (game === 'Abalone') {
    const move = mv as AbaloneMove;
    return `${move.cells.map(abaloneCellName).join('・')} ${['東', '北東', '北西', '西', '南西', '南東'][move.dir]}`;
  }
  if (game === 'Amazons') return moveNotation(mv as AmazonsMove);
  if (game === 'Trax') return traxNotation(mv as TraxMove);
  if (game === 'ChuShogi') {
    const move = mv as ChuShogiMove;
    const squares = [move.from, ...(move.via ? [move.via] : []), move.to];
    return `${squares.map(chuSquareLabel).join(' → ')}${move.promote ? ' 成' : ''}`;
  }
  if (game === 'BridgeNT') {
    const move = mv as BridgeNtMove;
    if ('provide_hands' in move) return '配牌確認';
    if ('play' in move) return `${suitLabel(move.play.card.suit)}${rankLabel(move.play.card.rank)}`;
  }
  return null;
}
